var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.params.data.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }